<div class="card-container">
  <mat-card fxLayout="column">
    <mat-form-field
      appearance="standard"
      style="padding: 0px 15px 0 15px;"
      fxFlex
    >
      <mat-label>Search</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        [(ngModel)]="searchTerm"
        (ngModelChange)="this.searchTermChanged.next($event)"
        placeholder="Type cart id or email..."
      />
    </mat-form-field>

    <table
      mat-table
      class="mat-elevation-8 mat-typography"
      [dataSource]="dataSource"
      matSort
    >
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-sort-header>Cart ID</th>
        <td *matCellDef="let item">{{ item.id }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th *matHeaderCellDef mat-sort-header>Email</th>
        <td *matCellDef="let item">
          {{ item.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fullName">
        <th *matHeaderCellDef mat-sort-header>Full Name</th>
        <td *matCellDef="let item">
          {{ item.fullName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="destination">
        <th *matHeaderCellDef mat-sort-header>Destination</th>
        <td *matCellDef="let item">
          {{ item.destination }}
        </td>
      </ng-container>

      <ng-container matColumnDef="nDays">
        <th *matHeaderCellDef mat-sort-header>n Days</th>
        <td *matCellDef="let item">
          {{ item.nDays }}
        </td>
      </ng-container>

      <ng-container matColumnDef="plan">
        <th *matHeaderCellDef mat-sort-header>Plan</th>
        <td *matCellDef="let item">
          {{ item?.plan }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-sort-header>Status</th>
        <td *matCellDef="let item">
          {{ item.status }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr
        class="clickable"
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="edit(row)"
      ></tr>
    </table>
  </mat-card>
</div>
